import {
    Component,
    forwardRef,
    ChangeDetectionStrategy,
    Input,
    OnInit,
    inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { first, tap } from 'rxjs/operators';

import { PatientTaskService } from 'planner-shared';

import { BaseBtnGroupComponent } from '../base-btn-group';

@Component({
    selector: 'app-optimization-settings-heavy-tasks-btn-group',
    templateUrl: './optimization-settings-heavy-tasks-btn-group.component.html',
    styleUrls: ['./optimization-settings-heavy-tasks-btn-group.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OptimizationSettingsHeavyTasksBtnGroupComponent),
            multi: true
        }
    ],
    imports: [NgClass, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptimizationSettingsHeavyTasksBtnGroupComponent extends BaseBtnGroupComponent implements OnInit {
    @Input() public disable: boolean;

    public items: number[];

    private readonly patientTaskService = inject(PatientTaskService);

    constructor() {
        super();
        this.items = [];
    }

    ngOnInit(): void {
        this.patientTaskService
            .getHeavyTaskLowerLimit()
            .pipe(
                first(),
                tap(lowerLimit => {
                    if (lowerLimit != null && lowerLimit > 0) {
                        for (let i = lowerLimit; i <= 9; i++) {
                            this.items.push(i === 9 ? null : i);
                        }
                        return;
                    }

                    this.disable = true;
                    for (let i = 1; i <= 9; i++) {
                        this.items.push(i === 9 ? null : i);
                    }
                })
            )
            .subscribe();
    }

    public override writeValue(value: number): void {
        this._value = value;
        this.changeDetectorRef.markForCheck();
    }
}
